import * as actions_invoices from 'actions/invoices-actions';
import * as actions_quickbooks from 'actions/quickbooks-actions';
import React, { useEffect, useState } from 'react';
import { FormBuilder, ValidateForm, ModalForm } from 'enspire-manager-framework';
import { INVOICES, PAYMENTS } from 'components/constants';
import { Table } from 'em-table';
import { payment_method_fields, payment_method_form_layout } from './receive-payment-form-layout';
import { sortByField } from 'components/common/toolbox';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';

var _ = require('lodash');

const ReceivePaymentForm = (props) => {

	/* Hooks ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

	const params = useParams();
	const dispatch = useDispatch();
	const history = useHistory();

	const quickbooksSettings = useSelector((store) => store.quickbooks.quickbooks);
	const invoices = useSelector((store) => store.invoices);

	const invoicesList = invoices?.invoices?.filter((invoice) => invoice.statusId != INVOICES.PAID.id) ?? [];

	const [openInvoices, setOpenInvoices] = useState([]);
	const [state, setState] = useState({
		populated: false,
		form_error: null,
		payment_method: payment_method_fields(),
		invoices: [],
	});
	
	const fromCustomerDashboard = (!parseInt(params?.request_id));

	/* Hooks ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

	useEffect(() => {
		// FOR ASSETS, WE NEED SOMETHING OTHER THAN params.customer_id
		dispatch(actions_invoices.subPaymentsByField(params.handle, 'customerId', params.customer_id));
		dispatch(actions_invoices.subInvoicesByField(params.handle, 'customerId', params.customer_id));

		return () => {
			var unsubscribe = invoices.payments_unsubscribe;
			if (typeof unsubscribe === 'function') unsubscribe();

			var unsubscribe = invoices.invoices_unsubscribe;
			if (typeof unsubscribe === 'function') unsubscribe();
		};
	}, []);

	useEffect(() => {
		if (invoicesList?.length) {
			
			var data = invoicesList?.map((invoice) => {
				let paymentsApplied = (invoice.payments?.reduce((total, b) => total + parseFloat(b.amount), 0.00) ?? 0.00);

				return ({
					_stripe_color: Object.values(INVOICES).find((o) => o.id == invoice.statusId)?.color,
					created: invoice.created,
					id: invoice.id,
					memo: invoice.memo,
					openBalance: (invoice.totals?.grandTotal ?? 0.00) - (paymentsApplied),
					originalAmount: invoice.totals?.grandTotal,
					payment: 0,
					payments: invoice.payments,
				})
			});
			data = sortByField(data, 'originalAmount', 'desc');
			setOpenInvoices(data);
		}
	}, [invoices?.invoices]);

	/* Handlers ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

	// edit form
	const handleChange = (event, value) => {
		let newValue = (value) ? value : event.target.value;
		let form_error = _.filter(state.form_error, (o) => { return o.field !== event.target.name; });
		setState(prev => ({ ...prev, form_error, payment_method: { ...state.payment_method, [event.target.name]: newValue } }));
	};
	// edit table items
	const handleEdit = (field, item, newValue) => {
		const index = openInvoices.findIndex((wo) => wo.id == item.id);
		if (index > -1) {
			let newInvoices = [...openInvoices];
			newInvoices[index].payment = (newValue <= item.openBalance) ? newValue : item.openBalance;

			if (newValue <= 0) newInvoices[index].checked = false;
			else newInvoices[index].checked = true;

			setOpenInvoices(newInvoices);
		}
	};
	const handleCheckbox = (item) => {
		let newInvoices = [...openInvoices];
		const index = newInvoices.findIndex((wo) => wo.id == item.id);
		if (index > -1) {
			newInvoices[index].checked = !newInvoices[index].checked;

			if (newInvoices[index].checked) { // Apply entire balance if checked
				newInvoices[index].payment = newInvoices[index].openBalance;
			} else {
				newInvoices[index].payment = 0;
			}
		}
		setOpenInvoices(newInvoices);
	};

	/* Actions ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

	const submitForm = (payment_method_form_layout) => {
		var form_error = ValidateForm(state.payment_method, payment_method_form_layout);
		setState(prev => ({ ...prev, form_error }));

		if (amountPaying <= 0) {
			window.toastr.error('The Payment Amount must be greater than zero', 'Invalid Payment Amount');
			return;
		}
		if (!form_error.length) {

			var paymentObject = {
				...state.payment_method,
				amount: parseFloat(amountPaying.toFixed(2)),
				customerId: params.customer_id,
				date: new Date(),
				deleted: false,
				invoices: openInvoices.filter((i) => i.checked),
				requestId: params.request_id,
				statusId: PAYMENTS.SUCCESS.id,
			};

			if (fromCustomerDashboard) delete paymentObject.requestId;

			dispatch(actions_invoices.saveNewPayment(params.handle, paymentObject, openBalance, amountPaying, (payment_id) => {
				dispatch(actions_quickbooks.updateQuickbooks({ handle: params.handle, type: 'payment' }, quickbooksSettings));
				if (props?.setState) {
					props.setState(prev => ({ ...prev, showEditPayment: false }));
				} else {
					history.goBack();
				}
			}));
		}
	};

	/* Constants ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

	const openBalance = openInvoices?.reduce((total, b) => total + parseFloat(b.openBalance ?? 0.00), 0.00);
	const amountPaying = openInvoices?.reduce((total, b) => total + parseFloat(b.payment ?? 0.00), 0.00);
	
	const receive_payment_layout = payment_method_form_layout(state.payment_method);

	/* Render ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

	return (

		<ModalForm {...props}
			modal_header={'Receive Payment'}
			cancel_button_title="Cancel"
			save_button_title={'Receive Payment'}
			submitFormHandler={() => submitForm(receive_payment_layout)}
			hide_cancel={true}
			show_spinner={invoices.payments_save_pending}
			confirm_button_disabled={amountPaying <= 0 || !state.payment_method.method}
			style={1}
		>
			<FormBuilder
				callbacks={{
					text: handleChange,
					select: handleChange,
				}}
				form_error={state.form_error}
				form={receive_payment_layout}
				record={state.payment_method}
			/>
			
			<h3>Outstanding Invoices</h3>
			<Table
				data={openInvoices}
				show_limit={false}
				columns={[
					{ name: 'ID', field: 'id' },
					{ name: 'Created', field: 'created', type: 'date', format: 'MM/DD/YYYY' },
					{ name: 'Memo', field: 'memo' },
					{ name: 'Amount', field: 'originalAmount', prefix: '$' },
					{ name: 'Balance', field: 'openBalance', type: 'number', format: 'usd' },
					{ name: 'Payment', field: 'payment', type: 'number', format: 'usd', edit: { type: 'usd', autoSelect: true, callback: (field, item, newValue) => handleEdit(field, item, newValue) } },
					{ name: '', field: 'checked', type: 'checkbox', callback: (item) => handleCheckbox(item)},
				]}
			/>

			<div className="row">
				<div className="col-12">
					{(amountPaying != 0) &&
						<div className="row">
							<div className="col-8 text-right">
								<h3 className="m-1">Payment Amount:</h3>
							</div>
							<div className="col-4 text-right">
								<h3 className="m-1">${amountPaying.toFixed(2)}</h3>
							</div>
						</div>
					}
				</div>
			</div>
		</ModalForm>
	);
};

export default ReceivePaymentForm;
